import type { PropsWithChildren } from "react";
import { Column, Columns } from "../columns";
import classes from "./team.module.css";

interface TeamBlockProps {
  name: string;
  title?: string;
  imageUrl: string;
  columnStructure?: string;
  classList?: Array<string>;
}

const TeamBlockSimple = ({ name, title, imageUrl }: TeamBlockProps) => {
  return (
    <div className={classes.marketing__teamblocksimple}>
      <img src={imageUrl} />
      <strong>{name}</strong>
      {title && <div>{title}</div>}
    </div>
  );
};

const TeamBlockLarge = ({
  name,
  title,
  imageUrl,
  children,
  columnStructure,
  classList,
}: PropsWithChildren<TeamBlockProps>) => {
  const columnStructureString = columnStructure
    ? columnStructure
    : "40% calc(60% - 2rem)";
  const allClasses = new Array(classes.marketing__teamblocklarge);
  if (classList) allClasses.push(...classList);

  return (
    <div className={allClasses.join(" ")}>
      <Columns columnStructure={columnStructureString}>
        <Column>
          <img
            src={imageUrl}
            style={{
              width: "100%",
              objectFit: "cover",
              borderRadius: "100%",
              aspectRatio: "1 / 1",
            }}
          />
        </Column>
        <Column>
          <strong>{name}</strong>
          {title && (
            <div className={classes.marketing__teamblocklarge_title}>
              {title}
            </div>
          )}
          {children}
        </Column>
      </Columns>
    </div>
  );
};

export { TeamBlockLarge, TeamBlockSimple };
